import React from "react";
import { Controller, useForm } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormGroup } from "@cofano/cck";
import { FormDialog } from "components/dialogs/Dialogs";
import { FormErrorMessage } from "components/form/FormErrorMessage";
import NumberInput from "components/cck/NumberInput";
import { createShipHoldSchema, CreateShipHoldSchemaInput, CreateShipHoldSchemaOutput } from "view/ships/utils/ship.schema";

interface ShipHoldDialogProps {
	open: boolean;
	onClose: () => void;
	refetch: (data: CreateShipHoldSchemaOutput) => void;
}

const ShipHoldDialog = ({ open, onClose, refetch }: ShipHoldDialogProps) => {

	const defaultValues = {
		rows: null,
		bays: null,
		tiers: null,
	};

	const { control, handleSubmit, reset } = useForm<CreateShipHoldSchemaInput, unknown, CreateShipHoldSchemaOutput>({
		resolver: zodResolver(createShipHoldSchema),
		defaultValues: defaultValues,
	});

	const handleOnClose = () => {
		onClose();
		reset(defaultValues);
	};

	const onSave = (data: CreateShipHoldSchemaOutput) => {
		refetch(data);
		handleOnClose();
	};

	return (
		<FormDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "HOLD" })}
			form='shipHoldForm'>
			<form onSubmit={(event) => void handleSubmit(onSave)(event)} id="shipHoldForm">
				<FormGroup
					label={intl.formatMessage({ id: "BAYPLAN_ROWS" })}
					labelPlacement="left-center"
					overflow="hidden"
					required>
					<Controller
						name='rows'
						control={control}
						render={({ field, formState }) => (
							<React.Fragment>
								<NumberInput {...field} decimalScale={0} autoFocus />
								<FormErrorMessage name={field.name} errors={formState.errors} />
							</React.Fragment>
						)} />
				</FormGroup>

				<FormGroup
					label={intl.formatMessage({ id: "BAYPLAN_BAYS" })}
					labelPlacement="left-center"
					overflow="hidden"
					required>
					<Controller
						name='bays'
						control={control}
						render={({ field, formState }) => (
							<React.Fragment>
								<NumberInput {...field} decimalScale={0} />
								<FormErrorMessage name={field.name} errors={formState.errors} />
							</React.Fragment>
						)} />
				</FormGroup>

				<FormGroup
					label={intl.formatMessage({ id: "BAYPLAN_TIERS" })}
					labelPlacement="left-center"
					overflow="hidden"
					required>
					<Controller
						name='tiers'
						control={control}
						render={({ field, formState }) => (
							<React.Fragment>
								<NumberInput {...field} decimalScale={0} />
								<FormErrorMessage name={field.name} errors={formState.errors} />
							</React.Fragment>
						)} />
				</FormGroup>
			</form>
		</FormDialog>
	);
};

export default ShipHoldDialog;
